import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectSiriusDelivery } from '../ngrx/store/deliveries/deliveries.selectors';
import { selectEnvironmentSlice } from '../ngrx/store/environment/environment.selectors';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private readonly store$ = inject(Store);

  private environmentSlice = this.store$.selectSignal(selectEnvironmentSlice);

  siriusDelivery = this.store$.selectSignal(selectSiriusDelivery);

  getStage(): string {
    return this.environmentSlice().stage!;
  }

  getMatomoApplicationId(): number {
    return this.environmentSlice().matomoApplicationId!;
  }

  getMatomoUrl(): string {
    return this.environmentSlice().matomoUrl!;
  }

  getMatomoInitFlag(): boolean {
    const matomoInit = this.environmentSlice().matomoInit;
    if (matomoInit === null || matomoInit === undefined) {
      return false;
    }
    if (typeof matomoInit === 'string') {
      return (matomoInit as string).toLowerCase() === 'true';
    }
    return Boolean(matomoInit);
  }

  getDeliveryGuid() {
    return this.environmentSlice().deliveryGuid;
  }

  getDeliveryName() {
    return this.environmentSlice().deliveryName;
  }

  getIsLocked() {
    return this.environmentSlice().isLocked;
  }

  getDeliveryIsLocked() {
    const isLocked: boolean = this.getIsLocked();
    const activationDate = this.getDeliveryActivationDate();
    return isLocked && !!activationDate;
  }

  getDeliveryActivationDate() {
    return this.environmentSlice().activationDate;
  }

  getBaseUrl() {
    return this.environmentSlice().baseUrl;
  }

  isReadOnly() {
    return this.environmentSlice().readOnly;
  }

  getMicroDeliveryBaseUrl(path: string) {
    const apiPrefix = path.indexOf('api') === -1;
    return `https://${this.getBaseUrl()}/zprs/gcp/microdelivery-service/${apiPrefix ? 'api/' : ''}${path}`;
  }

  getGroupServiceBaseUrl(path: string) {
    const apiPrefix = path.indexOf('api') === -1;
    return `https://${this.getBaseUrl()}/zprs/gcp/group-service/${apiPrefix ? 'api/' : ''}${path}`;
  }

  getHyperspaceOnboardingUrl() {
    return this.environmentSlice().hyperspaceOnboarding;
  }

  getHyperSpacePortalUrl() {
    return this.environmentSlice().hyperspacePortal;
  }

  get groupId() {
    return this.siriusDelivery()?.id;
  }
}
